module.exports = __webpack_public_path__ + "img/title.c95a5770.png";